import apiClient from './api';

export const preguntaService = {
  // Listar todas las preguntas
  getAllPreguntas: async () => {
    const response = await apiClient.get('/preguntas');
    return response.data;
  },

  // Listar preguntas por examen
  getPreguntasByExamen: async (examenId) => {
    const response = await apiClient.get(`/preguntas/examen/${examenId}`);
    return response.data;
  },

  // Crear nueva pregunta
  createPregunta: async (preguntaData) => {
    const response = await apiClient.post('/preguntas', preguntaData);
    return response.data;
  },

  // Actualizar pregunta
  updatePregunta: async (id, preguntaData) => {
    const response = await apiClient.put(`/preguntas/${id}`, preguntaData);
    return response.data;
  },

  // Eliminar pregunta
  deletePregunta: async (id) => {
    const response = await apiClient.delete(`/preguntas/${id}`);
    return response.data;
  },

  // Crear pregunta con imagen (FormData)
  createPreguntaWithImage: async (formData) => {
    const response = await apiClient.post('/preguntas', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Actualizar pregunta con imagen (FormData)
  updatePreguntaWithImage: async (id, formData) => {
    const response = await apiClient.put(`/preguntas/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};

export default preguntaService;
